import React, { useState } from "react";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import styles from "./Property.module.css";

// ⚠️ For testing only. Later move to .env and restrict in Google Console
const GOOGLE_MAPS_API_KEY = "AIzaSyDcS7ym_BctmQnedWGskID8BCMuiRxJi90";

function Property({ formData, setFormData }) {
  const [autocomplete, setAutocomplete] = useState(null);

  const updateField = (field, value) => {
    setFormData({
      ...formData,
      property: {
        ...(formData.property || {}),
        [field]: value,
      },
    });
  };

  const onLoad = (autoC) => {
    setAutocomplete(autoC);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place.formatted_address) {
        updateField("address", place.formatted_address);
      }
    }
  };

  return (
    <div className={styles.container}>
      <h3>Property Details</h3>

      {/* Google Places Autocomplete restricted to AU */}
      <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={["places"]}>
        <Autocomplete
          onLoad={onLoad}
          onPlaceChanged={onPlaceChanged}
          options={{ componentRestrictions: { country: "au" } }}
        >
          <input
            placeholder="Property Address"
            value={formData.property?.address || ""}
            onChange={(e) => updateField("address", e.target.value)}
            className={styles.fullWidth}
          />
        </Autocomplete>
      </LoadScript>

      <div className={styles.row}>
        <select
          value={formData.property?.type || ""}
          onChange={(e) => updateField("type", e.target.value)}
        >
          <option value="">Select Property Type</option>
          <option value="House">House</option>
          <option value="Townhouse">Townhouse</option>
          <option value="Unit/Apartment">Unit / Apartment</option>
          <option value="Land">Land</option>
        </select>

        <select
          value={formData.property?.usage || ""}
          onChange={(e) => updateField("usage", e.target.value)}
        >
          <option value="">Usage</option>
          <option value="Owner Occupied">Owner Occupied</option>
          <option value="Investment">Investment</option>
        </select>
      </div>

      <div className={styles.row}>
        <input
          type="number"
          placeholder="Estimated Value / Purchase Price ($)"
          value={formData.property?.value || ""}
          onChange={(e) => updateField("value", e.target.value)}
        />

        <input
          type="number"
          placeholder="Current Loan Balance ($)"
          value={formData.property?.loanBalance || ""}
          onChange={(e) => updateField("loanBalance", e.target.value)}
        />
      </div>

      <div className={styles.row}>
        <select
          value={formData.property?.lender || ""}
          onChange={(e) => updateField("lender", e.target.value)}
        >
          <option value="">Current Lender</option>
          <option value="CBA">CBA</option>
          <option value="ANZ">ANZ</option>
          <option value="Westpac">Westpac</option>
          <option value="NAB">NAB</option>
          <option value="Macquarie">Macquarie</option>
          <option value="Bankwest">Bankwest</option>
          <option value="AMP">AMP</option>
          <option value="Suncorp">Suncorp</option>
          <option value="ME Bank">ME Bank</option>
          <option value="Pepper">Pepper</option>
          <option value="Other">Other</option>
        </select>
      </div>
    </div>
  );
}

export default Property;
